import React, { useEffect, useState } from "react";
import "./AcercaDe.css";
import { obtenerInfoSistema } from "../utilities/infoSistema";
import { consultarVersionPublicada } from "../utilities/versionApp";
import { INFORMACION_ADICIONAL } from "../acercaDe";

const textoEstado = (estado) => {
  if (!estado) return "Comprobando…";
  switch (estado.estado) {
    case "vigente":
      return "✅ Esta pantalla está actualizada.";
    case "nueva":
      return `⚠️ Hay una versión más nueva publicada (${estado.idPublicado}). Actualiza la página con Ctrl + F5.`;
    case "sin_identificador":
      return "Versión de desarrollo: esta pantalla no trae identificador de versión.";
    default:
      return "No se pudo comprobar si hay una versión más nueva.";
  }
};

// Boton "i" del encabezado + ventana con la version y la informacion del sistema.
const AcercaDe = () => {
  const [abierto, setAbierto] = useState(false);
  const [info, setInfo] = useState(null);
  const [estadoVersion, setEstadoVersion] = useState(null);

  const abrir = () => {
    setInfo(obtenerInfoSistema());
    setEstadoVersion(null);
    setAbierto(true);
  };
  const cerrar = () => setAbierto(false);

  useEffect(() => {
    if (!abierto) return undefined;
    let activo = true;
    consultarVersionPublicada().then((r) => {
      if (activo) setEstadoVersion(r);
    });
    const alTeclear = (e) => {
      if (e.key === "Escape") setAbierto(false);
    };
    document.addEventListener("keydown", alTeclear);
    return () => {
      activo = false;
      document.removeEventListener("keydown", alTeclear);
    };
  }, [abierto]);

  const fila = (etiqueta, valor) =>
    valor ? (
      <div className="acerca-fila">
        <dt>{etiqueta}</dt>
        <dd>{valor}</dd>
      </div>
    ) : null;

  return (
    <>
      <button
        type="button"
        className="btn-header-acerca"
        onClick={abrir}
        aria-label="Acerca de"
        title="Acerca de"
      >
        ⓘ
      </button>

      {abierto && info && (
        <div className="acerca-overlay" onClick={cerrar}>
          <div
            className="acerca-dialogo"
            role="dialog"
            aria-modal="true"
            aria-labelledby="acerca-titulo"
            onClick={(e) => e.stopPropagation()}
          >
            <button type="button" className="acerca-cerrar" onClick={cerrar} aria-label="Cerrar">
              ✕
            </button>
            <h2 id="acerca-titulo">Acerca de</h2>
            <p className="acerca-nombre">
              <strong>{info.sistema}</strong>
              <br />
              {info.institucion}
            </p>

            <dl className="acerca-datos">
              {info.idBuild
                ? fila("Versión", info.fechaBuild || info.idBuild)
                : fila("Versión", "Desarrollo local (sin identificador de versión)")}
              {info.fechaBuild && fila("Identificador de versión", info.idBuild)}
              {fila("Rama de origen", info.rama)}
              {fila("Commit", info.commit)}
              {fila("Entorno", info.entorno)}
              {fila("Sitio", info.sitio)}
              {fila("Servidor de datos", info.servidorDatos)}
              {fila("Servidor de pagos en línea", info.servidorPagos)}
              {info.sesion && fila("Sesión del panel", [info.sesion.nombre, info.sesion.rol, info.sesion.plantel].filter(Boolean).join(" | "))}
            </dl>

            <p className="acerca-estado" role="status">
              {textoEstado(estadoVersion)}
            </p>

            {INFORMACION_ADICIONAL.length > 0 && (
              <div className="acerca-adicional">
                <h3>Información del sistema</h3>
                <dl className="acerca-datos">
                  {INFORMACION_ADICIONAL.map((dato) => fila(dato.titulo, dato.texto))}
                </dl>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AcercaDe;
